export const BEGIN_AJAX_CALL = "BEGIN_AJAX_CALL";
export const AJAX_CALL_ERROR = "AJAX_CALL_ERROR";
export const END_AJAX_CALL = "END_AJAX_CALL";

export const WAIT_FOR_EVENT_SUBSCRIBE = "WAIT_FOR_EVENT_SUBSCRIBE";
export const WAIT_FOR_EVENT_UNSUBSCRIBE = "WAIT_FOR_EVENT_UNSUBSCRIBE";
export const SIGNAL_R_EVENT_RECEIVED = "SIGNAL_R_EVENT_RECEIVED";
export const BEGIN_ASYNC_COMMAND = "BEGIN_ASYNC_COMMAND";
export const END_ASYNC_COMMAND = "END_ASYNC_COMMAND";

export const OIDC_USER_EXPIRING = "redux-oidc/USER_EXPIRING";

//NOTIFICATIONS
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const LOAD_NOTIFICATIONS_SUCCESS = "LOAD_NOTIFICATIONS_SUCCESS";

// OFFERS
export const CREATE_OFFER_SUCCEEDED = "CREATE_OFFER_SUCCEEDED";
export const LOAD_OFFERS_SUCCESS = "LOAD_OFFERS_SUCCESS";
export const LOAD_OFFER_HEADER_STARTED = "LOAD_OFFER_HEADER_STARTED";
export const LOAD_OFFER_HEADER_SUCCESS = "LOAD_OFFER_HEADER_SUCCESS";
export const LOAD_OFFER_FINANCIAL_PRODUCT_RULE_READONLY_FIELDS_SUCCESS =
  "LOAD_OFFER_FINANCIAL_PRODUCT_RULE_READONLY_FIELDS_SUCCESS";
export const LOAD_OFFER_FINANCIAL_PRODUCT_RULE_READONLY_FIELDS_STARTED =
  "LOAD_OFFER_FINANCIAL_PRODUCT_RULE_READONLY_FIELDS_STARTED";

export const RESET_CURRENT_OFFER = "RESET_CURRENT_OFFER";
export const RESET_NEXT_STATE_FOLDER_LIST = "RESET_NEXT_STATE_FOLDER_LIST";
export const LANGUAGE_CHANGED = "LANGUAGE_CHANGED";

export const LOAD_OFFER_CONFIG_SUCCESS = "LOAD_OFFER_CONFIG_SUCCESS";

export const UPDATE_OFFER_HEADER_SUCCESS = "UPDATE_OFFER_HEADER_SUCCESS";
export const UPDATE_OFFER_HEADER_PROPERTY = "UPDATE_OFFER_HEADER_PROPERTY";
export const LOAD_OFFER_DECISION_SELECTED_CONDITIONS_SUCCESS = "LOAD_OFFER_DECISION_SELECTED_CONDITIONS_SUCCESS";
export const LOAD_OFFER_DECISION_AVAILABLE_CONDITIONS_SUCCESS = "LOAD_OFFER_DECISION_AVAILABLE_CONDITIONS_SUCCESS";
export const UPDATE_OFFER_DECISION_SELECTED_CONDITIONS_SUCCESS = "UPDATE_OFFER_DECISION_CONDITIONS_SUCCESS";
export const LOAD_OFFER_DECISION_FINANCED_ASSETS_SUCCESS = "LOAD_OFFER_DECISION_FINANCED_ASSETS_SUCCESS";
export const LOAD_OFFER_DECISION_SUBSEQUENT_CONDITIONS_SUCCESS = "LOAD_OFFER_DECISION_SUBSEQUENT_CONDITIONS_SUCCESS";
export const UPDATE_OFFER_DECISION_SUBSEQUENT_CONDITIONS_SUCCESS =
  "UPDATE_OFFER_DECISION_SUBSEQUENT_CONDITIONS_SUCCESS";

export const LOAD_OFFER_WARNINGS_SUCCESS = "LOAD_OFFER_WARNINGS_SUCCESS";

export const LOAD_DOC_ENTITIES_STARTED = "LOAD_DOC_ENTITIES_STARTED";
export const LOAD_DOC_ENTITIES_SUCCEEDED = "LOAD_DOC_ENTITIES_SUCCEEDED";

export const LOAD_DOC_PERSONS_STARTED = "LOAD_DOC_PERSONS_STARTED";
export const LOAD_DOC_PERSONS_SUCCEEDED = "LOAD_DOC_PERSONS_SUCCEEDED";

export const LOAD_OFFER_SOURCES_SUCCESS = "LOAD_SOURCES_SUCCESS";
export const LOAD_OFFER_CHANNELS_SUCCESS = "LOAD_CHANNELS_SUCCESS";
export const LOAD_COMMENTS_CONFIG = "LOAD_COMMENTS_CONFIG";

export const LOAD_PARTNER_PRIORITIES_SUCCESS = "LOAD_PARTNER_PRIORITIES_SUCCESS";

export const UPDATE_OFFER_USER_PREFERENCES_SUCCESS = "UPDATE_OFFER_USER_PREFERENCES_SUCCESS";
export const LOAD_OFFER_USER_PREFERENCES_SUCCESS = "LOAD_OFFER_USER_PREFERENCES_SUCCESS";

export const UPDATE_OFFER_SELECTED_USER_PREFERENCE_SUCCESS = "UPDATE_OFFER_SELECTED_USER_PREFERENCE_SUCCESS";
export const LOAD_OFFER_SELECTED_USER_PREFERENCE_SUCCESS = "LOAD_OFFER_SELECTED_USER_PREFERENCE_SUCCESS";

export const LOAD_OFFER_DEFAULT_USER_PREFERENCE_SUCCESS = "LOAD_OFFER_DEFAULT_USER_PREFERENCE_SUCCESS";

export const GENERATE_DOCUMENT_REPORT_STARTED = "GENERATE_DOCUMENT_REPORT_STARTED";
export const GENERATE_DOCUMENT_REPORT_SUCCEEDED = "GENERATE_DOCUMENT_REPORT_SUCCEEDED";
export const GENERATE_DOCUMENT_REPORT_FAILED = "GENERATE_DOCUMENT_REPORT_FAILED";

// USER
export const LOAD_USER_INFO_SUCCESS = "LOAD_USER_INFO_SUCCESS";
export const LOAD_USER_INFO_STARTED = "LOAD_USER_INFO_STARTED";

//DICTIONARIES
export const LOAD_DEALER_SUCCESS = "LOAD_DEALER_SUCCESS";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const LOAD_USER_PARTNER_SUCCESS = "LOAD_USER_PARTNER_SUCCESS";
export const LOAD_FINANCING_TYPES_SUCCESS = "LOAD_FINANCING_TYPES_SUCCESS";
export const LOAD_OFFER_TYPES_SUCCESS = "LOAD_OFFER_TYPES_SUCCESS";
export const LOAD_TRANSACTION_CATEGORIES_SUCCESS = "LOAD_TRANSACTION_CATEGORIES_SUCCESS";
export const LOAD_CURRENCIES_SUCCESS = "LOAD_CURRENCIES_SUCCESS";
export const LOAD_CURRENCIES_STARTED = "LOAD_CURRENCIES_STARTED";
export const LOAD_COMMISSION_TYPES_SUCCESS = "LOAD_COMMISSION_TYPES_SUCCESS";
export const LOAD_COMMISSION_TYPES_STARTED = "LOAD_COMMISSION_TYPES_STARTED";
export const LOAD_LEASING_EXPENSE_TYPES_STARTED = "LOAD_LEASING_EXPENSE_TYPES_STARTED";
export const LOAD_LEASING_EXPENSE_TYPES_SUCCESS = "LOAD_LEASING_EXPENSE_TYPES_SUCCESS";
export const LOAD_RESPONSIBLES_SUCCESS = "LOAD_RESPONSIBLES_SUCCESS";
export const LOAD_RESPONSIBLE_SUCCESS = "LOAD_RESPONSIBLE_SUCCESS";
export const LOAD_STATES_SUCCESS = "LOAD_STATES_SUCCESS";
export const LOAD_OFFER_VISIBILITY_LEVELS_SUCCESS = "LOAD_OFFER_VISIBILITY_LEVELS_SUCCESS";
export const LOAD_FOLDER_VISIBILITY_LEVELS_SUCCESS = "LOAD_FOLDER_VISIBILITY_LEVELS_SUCCESS";
export const LOAD_PARTNER_FILE_VISIBILITY_LEVELS_SUCCESS = "LOAD_PARTNER_FILE_VISIBILITY_LEVELS_SUCCESS";
export const LOAD_APPROVAL_TYPES_SUCCESS = "LOAD_APPROVAL_TYPES_SUCCESS";
export const LOAD_OFFER_DECISION_TYPES_STARTED = "LOAD_OFFER_DECISION_TYPES_STARTED";
export const LOAD_OFFER_DECISION_TYPES_SUCCESS = "LOAD_OFFER_DECISION_TYPES_SUCCESS";
export const LOAD_OFFER_INVOICING_EXCHANGE_RATES_STARTED = "LOAD_OFFER_INVOICING_EXCHANGE_RATES_STARTED";
export const LOAD_OFFER_INVOICING_EXCHANGE_RATES_SUCCESS = "LOAD_OFFER_INVOICING_EXCHANGE_RATES_SUCCESS";
export const LOAD_OFFER_REFERENCE_INTERESTS_STARTED = "LOAD_OFFER_REFERENCE_INTERESTS_STARTED";
export const LOAD_OFFER_REFERENCE_INTERESTS_SUCCESS = "LOAD_OFFER_REFERENCE_INTERESTS_SUCCESS";
export const LOAD_OFFER_ACQUISITION_EXCHANGE_RATES_SUCCESS = "LOAD_OFFER_ACQUISITION_EXCHANGE_RATES_SUCCESS";
export const LOAD_OFFER_ACQUISITION_EXCHANGE_RATES_STARTED = "LOAD_OFFER_ACQUISITION_EXCHANGE_RATES_STARTED";
export const LOAD_OFFER_CREDIT_FINANCING_LINES_SUCCESS = "LOAD_OFFER_CREDIT_FINANCING_LINES_SUCCESS";
export const LOAD_OFFER_CREDIT_FINANCING_LINES_STARTED = "LOAD_OFFER_CREDIT_FINANCING_LINES_STARTED";
export const LOAD_RISK_ANALYSIS_TYPES_STARTED = "LOAD_RISK_ANALYSIS_TYPES_STARTED";
export const LOAD_RISK_ANALYSIS_TYPES_SUCCESS = "LOAD_RISK_ANALYSIS_TYPES_SUCCESS";
export const LOAD_INVOICING_BANK_LIST_STARTED = "LOAD_INVOICING_BANK_LIST_STARTED";
export const LOAD_INVOICING_BANK_LIST_SUCCESS = "LOAD_INVOICING_BANK_LIST_SUCCESS";
export const LOAD_PRICE_TYPES_STARTED = "LOAD_PRICE_TYPES_STARTED";
export const LOAD_PRICE_TYPES_SUCCESS = "LOAD_PRICE_TYPES_SUCCESS";
export const LOAD_OFFER_SCHEDULE_TYPES_SUCCESS = "LOAD_OFFER_SCHEDULE_TYPES_SUCCESS";
export const LOAD_OFFER_SCHEDULE_TYPES_STARTED = "LOAD_OFFER_SCHEDULE_TYPES_STARTED";
export const LOAD_SCHEDULE_CELL_PARAMS_SUCCESS = "LOAD_SCHEDULE_CELL_PARAMS_SUCCESS";
export const LOAD_PARTNER_LEGAL_FORMS_STARTED = "LOAD_PARTNER_LEGAL_FORMS_STARTED";
export const LOAD_PARTNER_LEGAL_FORMS_SUCCESS = "LOAD_PARTNER_LEGAL_FORMS_SUCCESS";
export const LOAD_DIMENSION_PERIODS_STARTED = "LOAD_DIMENSION_PERIODS_STARTED";
export const LOAD_DIMENSION_PERIODS_SUCCESS = "LOAD_DIMENSION_PERIODS_SUCCESS";
export const LOAD_SCORING_CATEGORY_OPTIONS_SUCCESS = "LOAD_SCORING_CATEGORY_OPTIONS_SUCCESS";
export const LOAD_SCORING_CATEGORY_OPTIONS_STARTED = "LOAD_SCORING_CATEGORY_OPTIONS_STARTED";
export const LOAD_WARRANTY_TYPES_STARTED = "LOAD_WARRANTY_TYPES_STARTED";
export const LOAD_WARRANTY_TYPES_SUCCESS = "LOAD_WARRANTY_TYPES_SUCCESS";
export const LOAD_PARTNERS_FILTERED_SUCCEEDED = "LOAD_PARTNERS_FILTERED_SUCCEEDED";
export const LOAD_PARTNERS_FILTERED_STARTED = "LOAD_PARTNERS_FILTERED_STARTED";
export const LOAD_PARTNERS_FILTERED_FAILED = "LOAD_PARTNERS_FILTERED_FAILED";
export const LOAD_BANK_ACCOUNT_TYPES_STARTED = "LOAD_BANK_ACCOUNT_TYPES_STARTED";
export const LOAD_BANK_ACCOUNT_TYPES_SUCCEEDED = "LOAD_BANK_ACCOUNT_TYPES_SUCCEEDED";
export const LOAD_BANK_ACCOUNT_TYPES_FAILED = "LOAD_BANK_ACCOUNT_TYPES_FAILED";
export const LOAD_ADDRESS_TYPES_STARTED = "LOAD_ADDRESS_TYPES_STARTED";
export const LOAD_ADDRESS_TYPES_SUCCEEDED = "LOAD_ADDRESS_TYPES_SUCCEEDED";
export const LOAD_ADDRESS_TYPES_FAILED = "LOAD_ADDRESS_TYPES_FAILED";
export const LOAD_VERIFICATION_TYPES_STARTED = "LOAD_VERIFICATION_TYPES_STARTED";
export const LOAD_VERIFICATION_TYPES_SUCCEEDED = "LOAD_VERIFICATION_TYPES_SUCCEEDED";
export const LOAD_VERIFICATION_TYPES_FAILED = "LOAD_VERIFICATION_TYPES_FAILED";
export const LOAD_CHECKLISTS_SUCCEEDED = "LOAD_CHECKLISTS_SUCCEEDED";
export const LOAD_CHECKLISTS_FAILED = "LOAD_CHECKLISTS_FAILED";
export const LOAD_SIGNATURE_ROLES_STARTED = "LOAD_SIGNATURE_ROLES_STARTED";
export const LOAD_SIGNATURE_ROLES_SUCCEEDED = "LOAD_SIGNATURE_ROLES_SUCCEEDED";
export const LOAD_SIGNATURE_ROLES_FAILED = "LOAD_SIGNATURE_ROLES_FAILED";
export const LOAD_INTEREST_TYPES_STARTED = "LOAD_INTEREST_TYPES_STARTED";
export const LOAD_INTEREST_TYPES_SUCCEEDED = "LOAD_INTEREST_TYPES_SUCCEEDED";
export const LOAD_INTEREST_TYPES_FAILED = "LOAD_INTEREST_TYPES_FAILED";
export const LOAD_GENDER_TYPES_STARTED = "LOAD_GENDER_TYPES_STARTED";
export const LOAD_GENDER_TYPES_SUCCEEDED = "LOAD_GENDER_TYPES_SUCCEEDED";
export const LOAD_GENDER_TYPES_FAILED = "LOAD_GENDER_TYPES_FAILED";
export const LOAD_COUNTRIES_SUCCESS = "LOAD_COUNTRIES_SUCCESS";
export const LOAD_COUNTIES_SUCCESS = "LOAD_COUNTIES_SUCCESS";
export const LOAD_CITIES_SUCCESS = "LOAD_CITIES_SUCCESS";
export const LOAD_CITIZENSHIPS_SUCCESS = "LOAD_CITIZENSHIPS_SUCCESS";
export const LOAD_PARTNER_ROLES_STARTED = "LOAD_DICTIONAY_PARTNER_ROLES_STARTED";
export const LOAD_PARTNER_ROLES_SUCCEEDED = "LOAD_DICTIONAY_PARTNER_ROLES_SUCCEEDED";
export const LOAD_ACTIVITY_FIELDS_SUCCEEDED = "LOAD_ACTIVITY_FIELDS_SUCCEEDED";
export const LOAD_CONTRACT_TYPES_STARTED = "LOAD_CONTRACT_TYPES_STARTED";
export const LOAD_CONTRACT_TYPES_SUCCEEDED = "LOAD_CONTRACT_TYPES_SUCCEEDED";
export const LOAD_CONTRACT_TYPES_FAILED = "LOAD_CONTRACT_TYPES_FAILED";
export const LOAD_ASSET_CATEGORIES_STARTED = "LOAD_ASSET_CATEGORIES_STARTED";
export const LOAD_ASSET_CATEGORIES_SUCCEEDED = "LOAD_ASSET_CATEGORIES_SUCCEEDED";
export const LOAD_ASSET_CLASSIFICATIONS_STARTED = "LOAD_ASSET_CLASSIFICATIONS_STARTED";
export const LOAD_ASSET_CLASSIFICATIONS_SUCCEEDED = "LOAD_ASSET_CLASSIFICATIONS_SUCCEEDED";
export const LOAD_PARTNER_POSITIONS_STARTED = "LOAD_PARTNER_POSITIONS_STARTED";
export const LOAD_PARTNER_POSITIONS_SUCCEEDED = "LOAD_PARTNER_POSITIONS_SUCCEEDED";
export const LOAD_CONTACT_MODE_TYPES_STARTED = "LOAD_CONTACT_MODE_TYPES_STARTED";
export const LOAD_CONTACT_MODE_TYPES_SUCCESS = "LOAD_CONTACT_MODE_TYPES_SUCCESS";

//DASHBOARD
export const LOAD_OFFER_STATS_SUCCESS = "LOAD_OFFER_STATS_SUCCESS";
export const LOAD_ACTIVE_CONTRACT_CHART_DATA_SUCCESS = "LOAD_ACTIVE_CONTRACT_CHART_DATA_SUCCESS";
export const LOAD_AVERAGE_TIME_STATES_SUCCESS = "LOAD_AVERAGE_TIME_STATES_SUCCESS";
export const LOAD_ACTIVITIES_SUCCESS = "LOAD_ACTIVITIES_SUCCESS";
export const ALL_FRONTEND_NOTIFICATIONS_DISMISSED = "ALL_FRONTEND_NOTIFICATIONS_DISMISSED";

//server events
export * from "../eventTypes";

export const SIDEBAR_DRAWER_SELECTED = "SIDEBAR_DRAWER_SELECTED";
